module.exports = __webpack_public_path__ + "static/media/product-small-02.eeb31b1b.png";